import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DeleteGedcomComponent } from 'src/app/components/modal/delete-gedcom/delete-gedcom.component';

@Component({
  selector: 'app-wizard-gedcom',
  templateUrl: './wizard-gedcom.component.html',
  styleUrls: ['./wizard-gedcom.component.scss']
})
export class WizardGedcomComponent implements OnInit {

  gedcom: any = [];
  gedcomLength: number = 0;
  displayedColumns: string[] = ['filename', 'uploaded', 'individuals', 'size', 'delete'];

  @Output() gedcomEvent = new EventEmitter<any>();
  constructor(
    private apiService: ApiService,
    private auth: AuthService,
    private MatDialog: MatDialog
  ) { }

  gedcomUploaded(event) {
    if(event == 'stockGEDCOM'){
      this.getGedcomFiles();
    }
    else{
      this.gedcomEvent.emit(event)
    }
  }

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  delete(file) {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = true;
    dialogConfig.id = "alert-component";
    dialogConfig.data = {
      gedcomName: file.filename
    }
    const modalDialog = this.MatDialog.open(DeleteGedcomComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((result) => {
      if (result == 'success') {
        this.apiService.deleteGedcom(file.id).then((d) => {
          this.getGedcomFiles();
        }, err => {
          console.log(err)
          this.getGedcomFiles();
        })
      }
    })

  }

  getGedcomFiles() {
    this.gedcom = []
    this.apiService.getGedcoms().then((gedcoms: any) => {
      gedcoms.forEach(gedcom => {
        this.gedcom.push({ filename: gedcom.filename.split('-')[1], indis: gedcom.indis || 0, size: this.formatBytes(gedcom.size), uploaded: gedcom.uploaded, id: gedcom._id, publicGedcom: gedcom.publicGedcom })
      });

      this.gedcom.sort((a: any, b: any) => {
        return <any>new Date(b.uploaded) - <any>new Date(a.uploaded);
      });
    }, err => { console.log('error', err) })
  }

  ngOnInit(): void {
    this.auth.getToken();
    this.gedcomLength = this.gedcom.length;
    this.getGedcomFiles();
  }

}
